import type { RiskAnalysisItem } from "@/types/risk-analysis";
import type { WizardStepType, ReprezentantEntitate } from "@/types/risk-wizard";

export function validateSectorSelection(
  selectedSectorIds: string[] | null | undefined
): boolean {
  if (!selectedSectorIds) return false;
  return selectedSectorIds.length > 0;
}

export function validateAllSectorsProcessed(
  riskAnalyses: RiskAnalysisItem[],
  skippedSectorIds: Set<string>
): boolean {
  return riskAnalyses.every(
    (ra) => ra.has_populated_matrix || skippedSectorIds.has(ra.sector_id)
  );
}

export function validateAllSectorsCompleted(
  riskAnalyses: RiskAnalysisItem[]
): boolean {
  return (
    riskAnalyses.length > 0 &&
    riskAnalyses.every((ra) => ra.has_populated_matrix)
  );
}

export function validateReprezentant(
  reprezentant: ReprezentantEntitate
): boolean {
  return (
    !!reprezentant.prenume && !!reprezentant.nume && !!reprezentant.functia
  );
}

export function canProceedToNext(
  stepType: WizardStepType,
  context: {
    selectedSectorIds?: string[];
    riskAnalyses?: RiskAnalysisItem[];
    skippedSectorIds?: Set<string>;
    reprezentant?: ReprezentantEntitate;
  }
): boolean {
  switch (stepType) {
    case "sector-selection":
      return validateSectorSelection(context.selectedSectorIds);
    case "sector-matrix":
      return true;
    case "review":
      return validateAllSectorsCompleted(context.riskAnalyses ?? []);
    case "generate-report":
      return context.reprezentant
        ? validateReprezentant(context.reprezentant)
        : false;
    default:
      return false;
  }
}
